import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Amplify, Auth } from 'aws-amplify';
import { environment } from '../../../environment/environment';
import { AuthService } from '../../services/auth.service';

// Amplify.configure({
// 	Auth: environment.cognitoConfig
// });

@Component({
  selector: 'ozm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent {
  userdata: any;
  selectedCategory: any = null;

  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _authService: AuthService
  ) { }

  ngOnInit() {
    this.userdata = this._authService.accessToken;
    console.log('this.accessToken:\n' + this._authService.accessToken);

    if (this._authService.accessToken !== null && this._authService.accessToken !== '') {
      this.userdata = this._authService.accessToken;
    } else {
      this._authService.accessToken = '';
    }

    const idToken = this._authService.idToken;
    // console.log('this.idToken:\n'+ this.userdata);
    // console.log('idToken: '+idToken);
  }


  public async logout() {
    await this._authService.signOut();
    await this._router.navigateByUrl('/login');
  }

  slides_url = [
    {
      url: 'category-list',
      name: 'category-list',
    },
    {
      url: 'sub-category-list',
      name: 'sub-category',
    },
    {
      url: 'appli-list',
      name: 'appli',
    },
    {
      url: 'offer-list',
      name: 'offer',
    },
    {
      url: 'offer-group-list',
      name: 'offer-group',
    },
    {
      url: 'banner-ad-list',
      name: 'banner-ad',
    },
    {
      url: 'icon-list',
      name: 'icon',
    },
    {
      url: 'admin-feedback',
      name: 'feedback',
    },
    {
      url: 'icon-background',
      name: 'icon-background',
    },
    {
      url: 'admin-cashback',
      name: 'admin-cashback',
    },
  ];


  //This is using cognito hosted ui authentication
  public signIn() {
    try {
      Auth.federatedSignIn();
      console.log('Signed in successfully')
    } catch (error) {
      console.log('Error signing in:', error);
    }
  }

  get accessToken(): string {
    return localStorage.getItem('accessToken') ?? '';
  }

  public async signOut() {
    try {
      await Auth.signOut();
      // await this._authService.signOut();
      localStorage.clear();
      console.log('Signed out successfully');
    } catch (error) {
      console.log('Error signing out:', error);
    }
  }
  // ===================== Below are not used as of now ============================
  isUserLoggedIn() {
    // return true
    if (!this._authService.isTokenExpired) {
      return true;
    } else {
      return false;
    }
  }

  navigateTo(data: any) {
    this._router.navigate([data])
  }

  navigateToSection(section: string) {

    // Cashback has its own page
    if (section === 'Cashback') {
      this._router.navigate(['/cashback']);
      return;
    }

    // 🔥 VERY IMPORTANT - Clear selected category to deactivate sidebar items
    this.selectedCategory = null;
    
    // Emit event to reset sidebar selection
    sessionStorage.setItem('clearSidebarSelection', 'true');

    // Always use router navigation with fragment to ensure Angular triggers NavigationEnd
    this._router.navigate(['/home'], {
      fragment: section
    });
  }

}
